<div class="flex flex-middle flex-justify-between b-a b-col-52 bg-col-5 p-t-2 p-b-2 p-r p-l">
    <button class="icon-arrow-left fs-3"
            style="line-height: 0;"
            type="button"
            (click)="prevMonth()"
            aria-label="prev month"></button>

    <p class="p1"
       style="line-height: 19.5px;">{{currentMonth}}</p>
    <button class="icon-arrow-right fs-3"
            style="line-height: 0;"
            type="button"
            (click)="nextMonth()"
            aria-label="next month"></button>
</div>
<div class="bg-col-51 p-t-3 p-b-3 p-l p-r">
    <div class="flex flex-justify-between p-b-3 p-t-3">
        @for (name of dayLabels; track $index) {
        <div class="flex-span-1 w-2 center p2">{{name}}</div>
        }
    </div>

    @for (week of weeks; track week) {
    <div class="calendar-week p-t-1 p-b-1 flex flex-justify-between no-wrap">
        @for (day of week; track day) {
        <div class="calendar-day w-2 flex-span-1 flex flex-middle flex-justify-center pos-relative b-radius-ma">
            <button class="p2 calendar-day"
                    [attr.disabled]="day?.isDisabled || day?.otherMonth"
                    style="border-radius: 50%;"
                    [ngClass]="day?.isPicked ? 'bg-col-1 col-w' : 'col-1 bg-col-t'"
                    (click)="day ? pick(day) : null">{{day | date: 'd'}}
            </button>
        </div>
        }
    </div>
    }
</div>